<template lang="pug"> 
  .card.shadow.mb-4()
    .card-header.py-3(@keyup.esc="closeModal()")
      h3.m-0.font-weight-bold.text-primary() Please select a Platform
      i.nav-item.fas.fa-fw.fa-times.closeModal.pointer(v-if="!gandalf" @click="closeModal()")
    .card-body
      .row
        .col-lg-6.col-12
          .card.connectPlatform.border-left-primary.shadow.py-2(
            v-on:click="platformSelect('shopify')"
            v-bind:class="{active: platform, selected: shopify.selected}"
          )
            .card-body
              img(src="@/assets/img/shopify-bag.png")
              h3 Shopify
        .col-lg-6.col-12
          .card.connectPlatform.border-left-primary.shadow.py-2(
            v-on:click="platformSelect('custom')"
            v-bind:class="{active: platform, selected: custom.selected}"
          )
            .card-body
              //- img(src="@/assets/img/woo-commerce.png")
              img(src="@/assets/img/package-lg.png")
              h3 Custom

        //- .col-6
          .card.border-left-primary.shadow.py-2(
            v-on:click="platformSelect('woocommerce')"
            v-bind:class="{active: platform, selected: woocommerce.selected}"
          )
            .card-body
              img(src="@/assets/img/woo-commerce.png")
              p WooCommerce
      .connectPlatformForm
        transition( name="fade")
          .col-12
            .carrier.card.shadow.mb-4(v-if="platform == 'shopify'")
              //- .card-header.py-3
                h3.m-0.font-weight-bold.text-primary() Shopify
              .card-body.platformCard
                .row
                  .col-12
                    h4 Please visit: <a href="https://apps.shopify.com/returnpostage" target="_blank" >https://apps.shopify.com/returnpostage</a> or follow these steps to add your Shopify store: 
                  .col-12.shopify-addapp.text-left
                    h5 <b> Step 1:</b> From your Shopify Admin, start by clicking Apps on the Side Navigation Bar.
                    h5 <b> Step 2:</b> Click on "Visit Shopify App Store".
                    h5 <b> Step 3:</b> In the searchbar, search for "ReturnPostage Automate Returns".
                    h5 <b> Step 4:</b> Click on the ReturnPostage app page.
                    h5 <b> Step 5:</b> While on the ReturnPostage app page, click on "Add app" button.
                    h5 <b> Step 6:</b> After being redirected to your Shopify Admin, click on the "Install app" button.
                
                //- OLD WAY TO ADD SHOPIFY VIA URL:
                //- .row
                  .col-12(v-if="shopify.step==0")
                    h4 Please enter your Shopify store URL:
                    br
                    input.col-lg-6.col-12(
                      type="text", placeholder="https://SHOP-NAME.myshopify.com" 
                      v-model="shopify.storeUrl")
                    br
                    .col-12.text-right
                      button.btn.btn-primary( v-on:click="shopifyUrl") Next
                  .col-12(v-if="shopify.step == 1")
                    form( v-bind:action="`${shopify.url}`" method="GET")
                      p You provided this store URL: {{shopify.store_url}}
                      p You will be redirected to Shopify.com to log into your store after you click on the "Next" button.
                      p If you're already logged into your store, the login step will be skipped.
                      input( type="hidden" name="client_id" v-model="shopify.client_id" )
                      input( type="hidden" name="redirect_uri" v-model="shopify.redirect_uri" )
                      input( type="hidden" name="scope" v-model="shopify.scope")
                      .col-12(style="display:flex; justify-content:space-between;")
                        button.btn.btn-primary(v-on:click="shopify.step = 0") Back
                        button.btn.btn-primary.text-right Next
                  .col-12(v-if="shopify.step == 2")
                    div(v-if="shopify.success == 'true'")
                      h2 Congratulations!
                      p You have successfully connected your Shopify store with ReturnPostage
                      //- p If you haven't connect to a shipping carrier yet, please consider doing so
                      p <b>Note:</b> You will not be able to print shipping labels until you connect to a shipping carrier.
                      p Contact our support staff if you have any questions.
                    div(v-if="shopify.success =='false'")
                      h2 We are Sorry
                      p {{shopify.error}}
                      button(v-on:click="reset()") Try again
        transition( name="fade")
          .col-12
            .carrier.card.shadow.mb-4(v-if="platform == 'custom'")
              //- .card-header.py-3
                h3.m-0.font-weight-bold.text-primary() Custom
              .card-body.platformCard
                .row
                  .col-12()
                    h4 Please enter your store information
                  .col-12.platformRow                      
                    label Store Name
                    br
                    input.col-lg-6.col-12(
                      type="text", placeholder="name" 
                      v-model="custom.nickname")
                  .col-12.platformRow
                    label Store URL
                    br
                    input.col-lg-6.col-12(
                      type="text", placeholder="https://SHOP-NAME.com" 
                      v-model="custom.storeUrl")
                  .col-12.text-right
                    button.btn.btn-primary( v-on:click="customUrl") Add                   
                    div(v-if="custom.success == 'true'")
                      h2 Congratulations!
                      p You have successfully connected your Shopify store with ReturnPostage
                      p <b>Note:</b> You will not be able to print shipping labels until you connect to a shipping carrier.
                      p Contact our support staff if you have any questions.
                    div(v-if="custom.success =='false'")
                      h2 We are Sorry
                      p {{custom.error}}
                      button(v-on:click="reset()") Try again
        transition( name="fade")
          .col-12
            .carrier.card.shadow.mb-4(v-if="platform == 'woocommerce'")
              .card-header.py-3
                h3.m-0.font-weight-bold.text-primary() WooCommerce
              .card-body
                h1 WooCommerce stuff goes here


</template>

<script>
export default {
  name: 'ConnectPlatform',
  components: {
    
  },
  props:{
    gandalf:Boolean,
    oAuthReturn:Object
  },
  data:function(){
    return{

      platform:false,
      woocommerce:{
        selected:false
      },
      custom:{
        selected:false,
        url:null,
      },
      shopify:{
        step:0,
        selected:false,
        client_id:null,
        url:null,
        scope:null,
      }      
    }
  },
  watch:{
    woocommerce: {
      handler() {
        // localStorage.setItem('woocommerce', JSON.stringify(this.woocommerce));
      },
      deep: true,
    },
    shopify: {
      handler() {
        // localStorage.setItem('shopify', JSON.stringify(this.shopify));
      },
      deep: true,
    },
  },
  methods:{
    closeModal(){
      this.$emit('closeForm')
    },
    platformSelect(platform){
      this.woocommerce.selected = false;
      this.shopify.selected = false;  
      this.custom.selected = false;    
      this.platform = platform;
      this[platform].selected = true;
    },
    async customUrl(){
      let bodyFormData = new FormData();
      bodyFormData.append('storeUrl', this.custom.storeUrl);
      bodyFormData.append('nickname', this.custom.nickname);
      this.flash('Saving...', 'success')
      let response = await this.axios.post(`/rp/server/channel/add`, bodyFormData)
      if(response.data.api_channel._id){
        if(!this.gandalf){
          if(response.data.api_channel){
            let createWidget = await this.axios.post(`/widgetmanager/create`,{key:response.data.api_channel.apiKey})
            if (createWidget.data.success == true) {
              this.flash('New Platform Added', 'success');
              this.$emit('init');
              this.$emit('closeForm');
            }else{
              this.flash('Something went wrong with widget creation.', 'error');
              this.$emit('init');
              this.$emit('closeForm');
            }
          }else{
            this.flash('Something went wrong', 'error');
          }
        }else{
          if(response.data.api_channel){
            this.flash('New Platform Added', 'success');
            this.$emit('init');
            this.$emit('closeForm');
            let createWidget = await this.axios.post(`/widgetmanager/create`,{key:response.data.api_channel.apiKey})
            if (createWidget.data.success == true) {
              // this.flash('New Channel Added', 'success');
              // this.$emit('init');
              // this.$emit('closeForm');
            } else {
              this.flash('Something went wrong with widget creation', 'error');
              // this.$emit('init');
              // this.$emit('closeForm');
            }     
          } else {
            this.flash('Something went wrong', 'error');
          }
        }
      }else{
        this.flash('Sorry, there was an error', 'warning')
      }
      
    },

    async shopifyUrl(){
      var bodyFormData = new FormData();
      bodyFormData.append('storeUrl', this.shopify.storeUrl); 
      var response = await this.axios.post('/rp/server/connections/shopify', bodyFormData)
      if (response.data.error) {
        this.flash( response.data.error.message, 'error')
        this.shopify.client_id = null
        this.shopify.scope = null
        this.shopify.store_url = null
        this.shopify.url = null
        }
      else{
        this.shopify.step = 1;
        this.shopify.client_id = response.data.shopify_prepare_oauth.client_id
        this.shopify.scope = response.data.shopify_prepare_oauth.scope
        this.shopify.store_url = response.data.shopify_prepare_oauth.store_url
        this.shopify.url = response.data.shopify_prepare_oauth.url
        this.shopify.redirect_uri = response.data.shopify_prepare_oauth.redirect_uri
      }

    },
    async shopifyAuth(){
     
    },
    async reset(){
      this.woocommerce.selected = false;
      this.shopify.selected = false;   
      this.shopify.step = 0;
      this.woocommerce.step = 0;
      this.platform = null;
      this.$router.push({path:`/dashboard/wizard/2`})
      
      // this.platform = platform;
      // this[platform].selected = true;
    }
    
  },
  mounted(){
    if(!this.gandalf){
      document.onkeydown = evt => {
        evt = evt || window.event;
        if (evt.keyCode == 27) {
          this.$emit("closeForm");
        }
      };
    }
    if(this.gandalf){    
      localStorage.setItem('gandalf', true);      
    }else{
      localStorage.setItem('gandalf',false);
    }
    if(this.oAuthReturn.success){
      var x = this.oAuthReturn;
      this[x.platform].success = this.oAuthReturn.success; 
      this.platform = x.platform;
      this[x.platform].step = 2;
      if(x.success == 'false'){
        var err = x.error;
        if(err == 'duplicate_store'){
          this.flash('A store with that URL already exists. Please try another store URL.', 'error') 
          // this[x.platform].error = "A store with that URL already exists. Please try another store URL."
        }
        else if(err == 'access_denied') {
          this.flash('You did not give us permission to access your order data. If you canceled the process by mistake, you can try connecting your store to us again.', 'error')
          // this[x.plaform].error = "You did not give us permission to access your order data. If you canceled the process by mistake, you can try connecting your store to us again.";
        }
        else if(err == 'channel_creation_failed') {
          this.flash('A Shopify channel could not be created. Please try again.', 'error')
          // this[x.platform].error = "A Shopify channel could not be created. Please try again.";
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .shopify-addapp{
    h5{
      margin:30px 0;
    }
  }
  .closeModal{
    position:absolute;
    right:20px;
    top:20px;
  }
  .platformRow{
    margin-top:20px;
  }
  .btn{
    margin-top:30px;
  }
  .platformCard{
    padding:70px 20px;
  }
  .connectPlatform{
    height:250px;    
    margin-top:20px;  
    cursor: pointer;
    transition:height .2s, background-color .2s;
    img{      
      height:150px;
      width:auto;
    }
    h3{
      margin:10px 0;
    }
  }
  .connectPlatform.selected{
    background-color:rgba(0,0,0,.15);      
  }
  .connectPlatform:hover{
    background-color:rgba(0,0,0,.1)
  }
  .connectPlatform.active{
    height:150px;
    img{
      height:70px;   
    }
  }
  .connectPlatformForm{
    margin-top:50px;
  }
  .fade-enter-active {
    transition: opacity .4s;
  }
  .fade-leave-active {
    display:none;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

</style>